export default __webpack_public_path__ + "static/logo-vertical-33bbcf9ca546705781a71c49659ec884.svg";